module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/100k-inactive-c1d651b8b1c6570b57760ce6137ac267.png";